export const defaultTheme = {
  color: {
    black: "#000",
    white: "#fff",
    primary: "#ffa290",
    violet: "#e2e7ff",
    green: "#bae9d0",
    blue: "#b6e8f0",
    lightGray: "#f4f4f4",
    gray: "#898989",
    pink: "#f8ddf7"
  },
  breakpoints: {
    phoneSmall: "374px",
    phoneBig: "601px",
    tabletSmall: "769px",
    tabletBig: "1025px",
    laptopSmall: "1281px",
    laptopStandard: "1441px",
    laptopBig: "1601px",
  },
}
